module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-table"
  }, [(_vm.caseDatas.length > 0) ? _c('div', {
    staticClass: "mii-table mii-table-2",
    staticStyle: {
      "height": "8rem"
    }
  }, [_c('content-title', {
    attrs: {
      "title": "成本对比"
    }
  }), _vm._v(" "), _c('table', {
    class: {
      'table-style-2': 1, 'scroll-table': _vm.scroll_table
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "th-1"
  }, _vm._l((_vm.ths2), function(thData, indexn) {
    return _c('th', {
      attrs: {
        "colspan": _vm.caseDatas.length
      }
    }, [_vm._v(_vm._s(thData.label))])
  })), _vm._v(" "), _c('tr', [_vm._l((_vm.ths2), function(thData, index2) {
    return _vm._l((_vm.caseDatas), function(caseData, index) {
      return _c('th', {
        class: {
          'border-th': index === 0 && index2 !== 0
        }
      }, [_vm._v(_vm._s(caseData.name))])
    })
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.caseDatas[0]['result']['成本']), function(data) {
    return _c('tr', [_vm._l((_vm.ths2), function(thData, index) {
      return _vm._l((_vm.caseDatas), function(caseDataOne, indeCase) {
        return _c('td', {
          class: {
            'border-th': indeCase === 0 && index !== 0
          }
        }, [_vm._v(_vm._s(_vm.caseDatas[indeCase]['result']['成本'][0][thData.key]))])
      })
    })], 2)
  }))])], 1) : _vm._e(), _vm._v(" "), (_vm.caseDatas.length > 0) ? _c('div', {
    staticClass: "mii-table mii-table-2"
  }, [_c('div', {
    staticClass: "table-tool"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-zhankai-copy",
    on: {
      "click": function($event) {
        _vm.scroll_table_2 = !_vm.scroll_table_2
      }
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daochu",
    on: {
      "click": _vm.optPutFile
    }
  })])]), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": "结果对比"
    }
  }), _vm._v(" "), _c('table', {
    class: {
      'table-style-2': 1, 'scroll-table': _vm.scroll_table_2
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "th-1"
  }, _vm._l((_vm.ths), function(thData) {
    return _c('th', {
      attrs: {
        "colspan": thData.label === '时间' ? 1 : _vm.caseDatas.length
      }
    }, [_vm._v(_vm._s(thData.label))])
  })), _vm._v(" "), _c('tr', [_vm._l((_vm.ths), function(thData) {
    return [(thData.label === '时间') ? _c('th') : _vm._l((_vm.caseDatas), function(caseData, index1) {
      return _c('th', {
        class: {
          'border-th': index1 === 0
        }
      }, [_vm._v(_vm._s(caseData.name))])
    })]
  })], 2)]), _vm._v(" "), _c('tbody', {
    style: (_vm.table_style_height)
  }, _vm._l((_vm.caseDatas[0]['result']['调度方案']), function(data, index) {
    return _c('tr', {
      staticStyle: {
        "overflow": "auto",
        "max-height": "20rem"
      }
    }, [_vm._l((_vm.ths), function(thData) {
      return [(thData.label === '时间') ? _c('td', [_vm._v(_vm._s(_vm.caseDatas[0]['result']['调度方案'][index][thData.key]))]) : _vm._l((_vm.caseDatas), function(caseDataOne, indeCase) {
        return _c('td', {
          class: {
            'border-th': indeCase === 0
          }
        }, [_vm._v(_vm._s(_vm.caseDatas[indeCase]['result']['调度方案'][index][thData.key]))])
      })]
    })], 2)
  }))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8db1ebbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components_bit/CaseCompareTable.vue
// module id = 808
// module chunks = 1